// services/subjectService.js
import API from '../api/api';

export const subjectService = {
    createSubject: async (payload) => {
    const response = await API.post('/create_subject', payload);
    return response.data;
  },
  
  updateSubject: async (payload) => {
    const response = await API.post('/update_subject', payload);
    return response.data;
  },
  getSubjects: async () => {
    const response = await API.get('/get_subjects');
    return response.data.data || [];
  },
  
  deleteSubject: async (id) => {
    const response = await API.post('/delete_subject', { id });
    return response.data;
  },
};